module.exports = __webpack_public_path__ + "static/vzEye_iris-e5ea398d66d4af1b99c00df26457eab6.png";